export class ActivityStore {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.name = form.name;
      this.address = form.address;
      this.location = (form.latitude && form.longitude) ? `${form.latitude},${form.longitude}` : '0,0';
      this.uaEventCityId = form.citySelectVO.id;
    } else {
      this.clear();
    }
  }
  get location() {
    if (this.latitude && this.longitude) {
      return `${this.latitude},${this.longitude}`;
    } else {
      return '0,0';
    }
  }

  set location(location) {
    if (location) {
      this.latitude = location.split(',')[0];
      this.longitude = location.split(',')[1];
    } else {
      this.latitude = 0;
      this.longitude = 0;
    }
  }
  clear() {
    this.name = '';
    this.address = '';
    this.location = '';
    this.uaEventCityId = '';
  }
}
